import testUa from './testUa';

const isWeiXin = (): boolean => {
  const r = /(micromessenger)/gi;
  return testUa(r);
};

export default isWeiXin;
